import { useState, useEffect } from 'react';

const API_BASE = '/api';

// Enhanced user ID management that works with authentication
const getUserId = () => {
  let userId = localStorage.getItem('cf_user_id');
  if (!userId) {
    userId = 'user_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    localStorage.setItem('cf_user_id', userId);
  }
  return userId;
};

// Enhanced headers that work with both authenticated and anonymous users
const getHeaders = () => ({
  'Content-Type': 'application/json',
  'X-User-ID': getUserId()
});

// Make authenticated request - handles both cookie-based auth and header-based anonymous
const makeRequest = async (url, options = {}) => {
  const config = {
    ...options,
    headers: {
      ...getHeaders(),
      ...options.headers
    },
    credentials: 'include' // Always include cookies for authenticated users
  };

  return fetch(url, config);
};

export const useSalesHistory = (rollNumber) => {
  const [sales, setSales] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadSalesHistory = async () => {
    if (!rollNumber) {
      setSales([]);
      setLoading(false);
      return;
    }

    try {
      const response = await makeRequest(`${API_BASE}/sales/${rollNumber}`);
      const data = await response.json();

      // Sort by year and month descending (most recent first)
      const sortedSales = data.sort((a, b) => {
        if (a.sale_year !== b.sale_year) {
          return b.sale_year - a.sale_year;
        }
        return b.sale_month - a.sale_month;
      });

      setSales(sortedSales);
    } catch (error) {
      console.error('Error loading sales history:', error);
      setSales([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadSalesHistory();
  }, [rollNumber]);

  return {
    sales,
    loading
  };
};
